import { tuple } from '@bydesign-ui/utils';
export var BREAKPOINT_SIZE = tuple('xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl');
export var BREAKPOINT_WIDTHS = {
  xxs: 0,
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};
export function formatBreakpoints(breakpoints) {
  var innerBreakpoints = [];
  breakpoints.forEach(function (name) {
    var innerBreakpoint = {
      name: String(name),
      point: 0
    };

    if (typeof name === 'string') {
      innerBreakpoint.point = BREAKPOINT_WIDTHS[name];
    } else {
      innerBreakpoint.point = name;
    }

    innerBreakpoints.push(innerBreakpoint);
  });
  return innerBreakpoints;
}